<template>
  <v-snackbars :objects.sync="$alerts.items" class="snackbars">
    <template v-slot:default="item">
      <v-row class="align-center justify-start flex-nowrap gap pa-5">
        <template v-if="$alerts.items[item.index].icon">
          <v-icon v-if="typeof $alerts.items[item.index].icon === 'string'" >
            {{$alerts.items[item.index].icon}}
          </v-icon>
          <v-icon
              v-if="typeof $alerts.items[item.index].icon === 'object'"
              :color="$alerts.items[item.index].icon.color ?? 'white'"
              :size="$alerts.items[item.index].icon.size ?? 'auto'"
          >
            {{$alerts.items[item.index].icon.name}}
          </v-icon>
        </template>
        <div v-html="item.message"></div>
      </v-row>
    </template>
    <template v-slot:action="item">
      <template v-if="$alerts.items[item.index] === false">

      </template>
      <template v-else>
        <v-icon @click="item.close" class="pr-5">mdi-close</v-icon>
      </template>
    </template>
  </v-snackbars>
</template>

<script>
  import VSnackbars from "v-snackbars"

  export default {
    components: {
      "v-snackbars": VSnackbars
    }
  }
</script>

<style scoped>
  .snackbars {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #FFFFFF;
  }

  .gap {
    gap: 20px
  }

  .snackbars:deep(a) {
    color: #FFFFFF;
  }

</style>


